<template>
  <div>
    <fieldset class="col-14">
      <v-text-field v-model="search" label="Search" single-line hide-details ></v-text-field>
    </fieldset>

    <v-data-table :search="search" :headers="headersForDelegateAgent" :pagination.sync="paginationForDelegateAgent" :items="members" must-sort hide-actions item-key="userId">
      <template slot="items" slot-scope="props">
        <tr>
          <td>
            <label class="form-checkbox">
              <input type="checkbox" :value="props.item.userId" v-model="selected" :id="props.item.userId" :checked="selected.includes(props.item.userId)" @change="updateDelegated($event)">
              <i class="form-icon"></i>
            </label>
          </td>
          <td>{{ props.item.agentName }}</td>
          <td>{{ props.item.userId }}</td>
        </tr>
      </template>
    </v-data-table>
    <br />
  </div>
</template>

<script>
  // import VueMarkdown from 'vue-markdown'
  // import FileBox from './elements/FileBox.vue'
  import { mapGetters, mapMutations } from 'vuex'
  import { auctionRoles } from '../utils/PfxUtils.js'
  
  export default {
    name: 'DelegateAgents',
    components: {
      // VueMarkdown,
      // FileBox
    },
    data() {
      return {
        members: [],
        search: '',
        selected: [],
        headersForDelegateAgent: [
          { text: 'Delegated', align: 'left', value: '' },
          { text: 'Agent Name', align: 'left', value: 'agentName' },
          { text: 'Agent ID', align: 'left', value: 'userId' }
        ],
        paginationForDelegateAgent: {
          sortBy: 'agentName', descending: true, rowsPerPage: 100000000
        }
      }
    },
    computed: {
      ...mapGetters([
        'isAuctionEdit'
      ])
    },
     created() {
      this.loadTenantMembers()
      this.loadDelegatedAgents()
    },
    methods: {
      ...mapMutations([
        'setLoadingSpinner',
        'openDialog'
      ]),

      beforeNextStep() {
        return true
      },

      loadTenantMembers() {
        this.setLoadingSpinner(1)
        let auctionListingAgent = ''
        this.$PfxBackendApi.getAuctionParticipants('pipeline', this.$route.params.auctionId)
          .then(res => {
            console.log('getAuctionParticipants res', res)
            const roles = res.data || []
            const listingAgent = roles.filter(ar => ar.role === auctionRoles.LISTING_AGENT.value)
            auctionListingAgent = listingAgent[0].userId
          })
          .catch(err => console.error('getAuctionParticipants err', err))

        this.$PfxBackendApi.getTenantMembers().then(res => {
          console.log('getTenantMembers res', res)
          res.data.forEach(member => {
            let agent = {agentName: `${member.profile.firstName} ${member.profile.lastName}`, userId: `${member.profile.userId}`}
            if ( member.profile.userId !== auctionListingAgent ) {
              this.members.push(agent)
            }
          })
          this.loading = false
        }).catch(err => {
          console.error('getTenantMembers err', err)
          this.openDialog({
            title: 'Error',
            text: err.data.message,
            buttons: [{ title: 'Close this' }]
          })
        }).then(() => this.setLoadingSpinner('--'))
      },

      loadDelegatedAgents() {
        this.$PfxBackendApi.getAuctionDelegatedAgents(this.$route.params.auctionId).then(res => {
          console.log('getAuctionDelegatedAgents res', res)
          res.data.forEach(member => {
            this.selected.push(member.userId)
          })
        }).catch(err => {
          console.error('getAuctionDelegatedAgents err', err)
          this.openDialog({
            title: 'Error',
            text: err.data.message,
            buttons: [{ title: 'Close this' }]
          })
        })
      },

      updateDelegated(e){
        let data = []
        if (e.target.checked) {
          data = [ { userId: `${e.target.value}`, action: 0 } ]
          this.postDelegated(data)
        } else {
          data = [ { userId: `${e.target.value}`, action: 1 } ]
          this.postDelegated(data)
        }
      },

      postDelegated(data){
        this.$PfxBackendApi.postDelegatedAgents(this.$route.params.auctionId, data).then(res => {
          console.log('postDelegatedAgents res', res)
        }).catch(err => {
          console.error('postDelegatedAgents err', err)
          this.openDialog({
            title: 'Error',
            text: err.data.message,
            buttons: [{ title: 'Close this' }]
          })
        })
      }

    }
  }
</script>

<style lang="scss" scoped>
  @import 'node_modules/jeet/scss/index';

  .col-12 { @include column(1/2); }
  .col-13 { @include column(1/3); }
  .col-14 { @include column(1/4); }

</style>


// WEBPACK FOOTER //
// src/components/CreateListingDelegate.vue